import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const AddStageModal = ({ show, onHide, onAdd }) => {
  const [stageName, setStageName] = useState('');

  const handleAdd = () => {
    if (stageName.trim()) {
      onAdd(stageName.trim());
      setStageName('');
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="fw-semibold">Add New Stage</Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="px-4 pb-4">
        <Form.Group>
          <Form.Label className="fw-medium">
            Stage Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter stage name"
            value={stageName}
            onChange={(e) => setStageName(e.target.value)}
            className="py-3 rounded-3"
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="border-0 px-4 pb-4">
        <Button variant="light" className="px-4" onClick={onHide}>
          Cancel
        </Button>
        <Button 
          style={{ backgroundColor: '#FF6B00', borderColor: '#FF6B00' }}
          className="px-4"
          onClick={handleAdd}
        >
          Add Stage
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddStageModal;